import { render, staticRenderFns } from "./solutionAPS.vue?vue&type=template&id=65ba1a6d&scoped=true"
import script from "./solutionAPS.vue?vue&type=script&lang=js"
export * from "./solutionAPS.vue?vue&type=script&lang=js"
import style0 from "./solutionAPS.vue?vue&type=style&index=0&id=65ba1a6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ba1a6d",
  null
  
)

export default component.exports